module.exports = __webpack_public_path__ + "static/media/instagram_logo_icon.54fff3f5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/instagram_logo_icon.svg
// module id = 111
// module chunks = 0